import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';

// Packages
import { Button, Card, Col, Divider, Row, Skeleton, Space, Tag, Typography } from 'antd';
import { ToolFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Components
import LoadFilesTable from '../files/LoadFilesTable';

// Actions
import { confirm_file, discard_file, get_all_files, get_load_info, load_files_process } from '../../../redux/actions/selfActions';

// Utils
import { get_load_source_desc, get_load_status_desc, get_load_type_desc } from '../../../utils/get_status_desc';
import { get_load_status_color } from '../../../utils/get_color_status';

const LoadStatus = (props) => {
	const { messageApi } = props;

	const { load_id } = useParams();

	const { t } = useTranslation();

	const dispatch = useDispatch();

	const navigate = useNavigate();

	const { load_info_loading, load_info, self_errors } = useSelector(state => state.self);

	const [size, setSize] = useState(100);

	useEffect(() => {
		const filters = { load: load_id };
		dispatch(get_all_files(filters));
		dispatch(get_load_info(load_id));
	}, [load_id]);

	const view = (record) => {
		navigate(`/load-file/${record._id.$oid}/info`)
	}

	const confirm = (record) => {
		dispatch(confirm_file(messageApi, record._id.$oid));
	}

	const discard = (record) => {
		const filters = { load: load_id };
		dispatch(discard_file(messageApi, record._id.$oid, filters));
	}

	const process_load_files = () => {
		dispatch(load_files_process(messageApi, load_id));
	}

	return (
		<Row justify='center'>
			<Col lg={17} md={17} sm={24} xs={24}>
				<Typography.Title className='text-center' level={2}>Archivos de Carga</Typography.Title>

				<Card
					bordered={false}
				>
					<Skeleton loading={load_info_loading} active>
						<Row style={{ textAlign: 'center' }}>
							<Col span={24}>
								<Space direction='vertical'>
									<Typography.Title level={4} copyable={{ text: load_info?._id?.$oid, tooltips: [t('copyableText.copyId'), t('copyableText.copiedId')] }}>
										{load_info?.name}
									</Typography.Title>
									<Typography.Text type='secondary'>{load_info?.description}</Typography.Text>
								</Space>

								<Divider />

								<Space className='responsive-space' direction='horizontal' size={size}>
									<Typography.Text>
										<strong>{t('routesTable.headers.status')}:</strong> <Tag color={get_load_status_color(load_info?.status)}>{get_load_status_desc(load_info?.status)}</Tag>
									</Typography.Text>
									<Typography.Text>
										<strong>{t('loadStatusDetails.card.source')}:</strong> {get_load_source_desc(load_info?.source)}
									</Typography.Text>
									<Typography.Text>
										<strong>{t('loadFileInput.loadType')}:</strong> {get_load_type_desc(load_info?.load_type)}
									</Typography.Text>
								</Space>

								<Divider />

								<Space className='responsive-space' direction='horizontal' size={size}>
									<Typography.Text>
										<strong>{t('loadStatus.statusTable.date')}:</strong> {new Date(load_info?.date?.$date).toLocaleString(localStorage.getItem('i18nextLng'), { hour12: true })}
									</Typography.Text>
								</Space>

								<Divider />

								<Space className='responsive-space' direction='horizontal' size={size}>
									<Button
										type='primary'
										style={{ backgroundColor: '#faad14' }}
										icon={<ToolFilled />}
										onClick={() => process_load_files()}
									>
										{t('loadStatusDetails.process.button')}
									</Button>
								</Space>
							</Col>
						</Row>
					</Skeleton>
				</Card>

				<div className='mt-5'>
					<LoadFilesTable 
						onConfirm={confirm}
						onDiscard={discard}
						loadId={load_id}
					/>
				</div>
			</Col>
		</Row>
	);
}

LoadStatus.propTypes = {
	messageApi: PropTypes.object.isRequired
}

export default LoadStatus;
